import { useQuery } from '@tanstack/react-query'

import { getVoiceCloningTicket } from '../../service/user'

function useGetVoiceCloningTicket() {
  return useQuery({
    queryKey: ['get-user-voice-cloning-ticket'],
    queryFn: () => getVoiceCloningTicket(),
    staleTime: 6 * 1000,
  })
}

export default useGetVoiceCloningTicket
